import { useEffect } from 'react';

/**
 * Custom hook to load chat widget scripts and initialize the chat widget.
 * @param {boolean} shouldLoad - Flag to determine if scripts should be loaded
 */
export function useChatWidget(shouldLoad) {
  const scripts = [
    {
      id: 'jquery_script',
      url: 'https://code.jquery.com/jquery-3.6.0.min.js',
    },
    {
      id: 'zammad_form_script',
      url: 'https://support.work.henga.co/assets/form/form.js',
    },
    // {
    //   id: 'zammad_chat_script',
    //   url: 'https://support.work.henga.co/assets/chat/chat-no-jquery.min.js',
    // },
  ];

  function callback() {
    // new window.ZammadChat({
    //   chatId: 2,
    //   show: false,
    //   fontSize: '12px',
    // });
    if (window.$ && $('#zammad-feedback-form').ZammadForm) {
      // eslint-disable-next-line new-cap
      window.$('#zammad-feedback-form').ZammadForm({
        modal: true,
        showTitle: true,
        messageSubmit: 'Submit',
        messageTitle: 'Ask a question, report and issue or suggest a feature',
        messageThankYou:
          'Thank you for your inquiry. We will contact you as soon as possible.',
      });
    }
  }

  useEffect(() => {
    if (!shouldLoad) {
      return;
    }
    let loadedCount = 0;
    const loadedScripts = [];

    scripts.forEach(function ({ id, url }) {
      if (window.document.getElementById(id)) {
        loadedCount += 1;
        if (callback && loadedCount === scripts.length) {
          callback();
        }
        return;
      }

      const script = window.document.createElement('script');
      script.id = id;
      script.src = url;
      script.async = false;

      script.onload = function () {
        loadedCount += 1;
        if (callback && loadedCount === scripts.length) {
          callback();
        }
      };

      script.onerror = function () {
        console.error(`Failed to load script: ${url}`);
      };

      window.document.body.appendChild(script);
      loadedScripts.push(script);
    });

    return function () {
      loadedScripts.forEach(function (script) {
        if (script.parentElement) {
          script.parentElement.removeChild(script);
        }
      });
    };
  }, [scripts, callback]);
}
